// src/utils/placements.js
//
// Mode de présence d'une œuvre dans un lieu (doc §2.B) — « Comment l'œuvre
// est-elle conservée dans ce lieu ? ». Distinct du LIEU (« où ? »).
// Contenu FR/EN/DE porté par le module (cohérent avec conservationDiagnostic.js).

export const PRESENCE_MODES = [
  { key: "hung",     label: { fr: "Exposée / accrochée", en: "On display / hung", de: "Ausgestellt / aufgehängt" } },
  { key: "resting",  label: { fr: "Posée sur un support", en: "Resting on a support", de: "Auf einer Stütze abgestellt" } },
  { key: "flat",     label: { fr: "Rangée à plat", en: "Stored flat", de: "Flach gelagert" } },
  { key: "vertical", label: { fr: "Rangée verticalement", en: "Stored vertically", de: "Vertikal gelagert" } },
  { key: "wrapped",  label: { fr: "Emballée", en: "Wrapped", de: "Verpackt" } },
  { key: "crated",   label: { fr: "En caisse", en: "Crated", de: "In einer Kiste" } },
  { key: "rack",     label: { fr: "Sur rack ou grille", en: "On a rack or grid", de: "Auf Regal oder Gitter" } },
  { key: "showcase", label: { fr: "En vitrine", en: "In a display case", de: "In einer Vitrine" } },
  { key: "running",  label: { fr: "Installation en fonctionnement", en: "Installation running", de: "Installation in Betrieb" } },
  { key: "moved",    label: { fr: "Temporairement déplacée", en: "Temporarily moved", de: "Vorübergehend versetzt" } },
];

const MODE_MAP = Object.fromEntries(PRESENCE_MODES.map((m) => [m.key, m]));

export function placementLang(lang) {
  const l = String(lang || "fr").slice(0, 2);
  return ["fr", "en", "de"].includes(l) ? l : "fr";
}

export function presenceModeLabel(key, lang) {
  const m = MODE_MAP[key];
  if (!m) return "";
  const l = placementLang(lang);
  return m.label[l] || m.label.fr || key;
}
